import { Component } from '@angular/core';

@Component({
  selector: 'app-cards2-examples-8',
  templateUrl: './cards2-examples-8.component.html'
})
export class Cards2Examples8Component {}
